<div
  class="modal-warning"
  [class.modal-warning--info]="variant === 'info'"
  [attr.data-testid]="testId || null"
>
  <span class="material-symbols-outlined modal-warning__icon">{{ icon }}</span>
  <p class="modal-warning__message">
    <ng-content></ng-content>
  </p>
</div>
